export const StudentQuizConfigurationTranslations = {
  WHAT_DO_YOU_WANT_TO_PRACTICE: {
    es: '¿Qué quieres practicar?',
    en: 'What do you want to practice?',
    cat: 'Què vols practicar?',
    eus: 'Zer esan nahi duzu egin?',
    pt: 'O que você quer praticar?'
  },
  BACK: {
    es: 'Atrás',
    en: 'Back',
    cat: 'Tornar',
    eus: 'Erantzun',
    pt: 'Voltar'
  },
  CONTINUE: {
    es: 'Continuar',
    en: 'Continue',
    cat: 'Continuar',
    eus: 'Jarraitu',
    pt: 'Continuar'
  },
  SELECT_TAG: {
    es: 'Selecciona una formación',
    en: 'Select a course',
    cat: 'Selecciona una formació',
    eus: 'Ikusi kursu bat',
    pt: 'Selecione um curso'
  },
  SELECT_COURSE: {
    es: 'Selecciona un curso',
    en: 'Select a course',
    cat: 'Selecciona un curs',
    eus: 'Ikusi kursu bat',
    pt: 'Selecione um curso'
  },
  WHAT_QUESTIONS_DO_YOU_WANT_TO_ANSWER: {
    es: '¿Qué preguntas quieres responder?',
    en: 'What questions do you want to answer?',
    cat: 'Quines preguntes vols respondre?',
    eus: 'Zer galdera egin nahi duzu erantzun?',
    pt: 'Quais perguntas você quer responder?'
  },
  BLANKS: {
    es: 'En blanco',
    en: 'In blank',
    cat: 'En blanc',
    eus: 'Hutsik',
    pt: 'Em branco'
  },
  WRONGS: {
    es: 'Incorrectas',
    en: 'Incorrect',
    cat: 'Incorrectes',
    eus: 'Okerra',
    pt: 'Incorretas'
  },
  NEW: {
    es: 'Nuevas',
    en: 'New',
    cat: 'Noves',
    eus: 'Berria',
    pt: 'Novas'
  },
  SELECT_SECTIONS: {
    es: 'Selecciona los temas',
    en: 'Select topics',
    cat: 'Selecciona els temes',
    eus: 'Ikusi gaiak',
    pt: 'Selecione os temas'
  },
  ALL: {
    es: 'Todos',
    en: 'All',
    cat: 'Tots',
    eus: 'Guztira',
    pt: 'Todos'
  },
  START_QUIZ: {
    es: 'Iniciar test',
    en: 'Start quiz',
    cat: 'Iniciar test',
    eus: 'Hasi testua',
    pt: 'Iniciar teste'
  },
  PRACTICE_COUNT_one: {
    es: '{{count}} simulacro',
    en: '{{count}} practice',
    cat: '{{count}} simulacro',
    eus: '{{count}} simulazio',
    pt: '{{count}} simulado'
  },
  PRACTICE_COUNT_other: {
    es: '{{count}} simulacros',
    en: '{{count}} practices',
    cat: '{{count}} simulacros',
    eus: '{{count}} simulazioak',
    pt: '{{count}} simulados'
  },
  PRACTICAL_CASE_COUNT_one: {
    es: '{{count}} caso práctico',
    en: '{{count}} practical case',
    cat: '{{count}} cas pràctic',
    eus: '{{count}} praktika-kasu',
    pt: '{{count}} caso prático'
  },
  PRACTICAL_CASE_COUNT_other: {
    es: '{{count}} casos prácticos',
    en: '{{count}} practical cases',
    cat: '{{count}} casos pràctics',
    eus: '{{count}} praktika-kasuak',
    pt: '{{count}} casos práticos'
  },
  CHOOSE_PRACTICE_QUIZ: {
    es: 'Elige un simulacro',
    en: 'Choose a practice quiz',
    cat: 'Escolliu un simulacro',
    eus: 'Hautatu simulazio bat',
    pt: 'Escolha um simulado'
  },
  HOURS: {
    es: '{{count}} horas',
    en: '{{count}} hours',
    cat: '{{count}} hores',
    eus: '{{count}} ordu',
    pt: '{{count}} horas'
  },
  MINUTES: {
    es: '{{count}} minutos',
    en: '{{count}} minutes',
    cat: '{{count}} minuts',
    eus: '{{count}} minutu',
    pt: '{{count}} minutos'
  },
  HOURS_AND_MINUTES: {
    es: '{{hours}}h {{minutes}}min',
    en: '{{hours}}h {{minutes}}min',
    cat: '{{hours}}h {{minutes}}min',
    eus: '{{hours}}h {{minutes}}min',
    pt: '{{hours}}h {{minutes}}min'
  },
  EMPTY_QUIZZES: {
    es: 'Lo siento, no se han encontrado tests para esta formación',
    en: 'Sorry, no quizzes found for this course',
    cat: "Ho sento, no s'han trobat exàmens per a aquesta formació",
    eus: 'Barkatu, ez da exame bat aurkitu',
    pt: 'Desculpe, não foram encontrados exames para este curso'
  },
  NO_SECTIONS_FOUND: {
    es: 'No hemos encontrado temas con preguntas disponibles para este curso y tipo de examen',
    en: 'No sections found with available questions for this course and quiz mode',
    cat: "No s'ha trobat cap tema amb preguntes disponibles per a aquest curs i mode d'examen",
    eus: 'Ez dugu aurkitu ikastaro eta azterketa mota honetarako galderak dituen gairik.',
    pt: 'Não foram encontrados temas com questões disponíveis para este curso e modo de exame'
  },
  QUESTIONS_COUNT_other: {
    es: '{{count}} preguntas',
    en: '{{count}} questions',
    cat: '{{count}} preguntes',
    eus: '{{count}} galderak',
    pt: '{{count}} questões'
  },
  QUESTIONS_COUNT_one: {
    es: '{{count}} pregunta',
    en: '{{count}} question',
    cat: '{{count}} pregunta',
    eus: '{{count}} galdera',
    pt: '{{count}} questão'
  },
  NOT_QUIZZES_CREATED_YET: {
    es: 'Aún no hay preguntas para este curso',
    en: 'No quizzes created yet for this course',
    cat: "No s'han creat preguntes per a aquest curs",
    eus: 'Oraindik ez dago galderarik ikastaro honetarako',
    pt: 'Não há questões criadas para este curso'
  }
};
